module.exports = "<img class='song-info-avatar' md-list-avatar src=\"{{image}}\" style=\"max-width: 100%;\" default-src />\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/song-info/song-info-avatar/song-info-avatar.component.html
// module id = ./src/app/player/song-info/song-info-avatar/song-info-avatar.component.html
// module chunks = main